import { Flex, Kbd } from '@chakra-ui/react'
import React from 'react'
import Text, { FontStyle } from '~/components/core/Text'
import { KbdVariants } from '~/components/shared/componentStyles/Kbd.style'

interface KeyboardKeyProps {
  text?: string
  fontStyle?: FontStyle
  textColor?: string
  height?: number
  width?: number | 'auto'
}

const KeyboardKeyWrapper = ({ children }) => {
  return (
    <Flex justifyContent={'center'} alignItems={'center'}>
      {children}
    </Flex>
  )
}

interface KeyBoxProps {
  width: string
  height: number
  children?: React.ReactNode
}

const KeyBox = ({ children }: KeyBoxProps) => {
  return <Kbd variant={KbdVariants.Mango}>{children}</Kbd>
}

const KeyboardKey = ({
  text = '',
  fontStyle = FontStyle.Normal,
  textColor,
  height = 30,
  width = 'auto',
}: KeyboardKeyProps) => {
  return (
    <KeyboardKeyWrapper>
      <KeyBox height={height} width={width === 'auto' ? width : `${width}px`}>
        <Text text={text} fontStyle={fontStyle} color={textColor} />
      </KeyBox>
    </KeyboardKeyWrapper>
  )
}

export default KeyboardKey
export type { KeyboardKeyProps }
